<mat-card class="mainclass">

  <div class="header">
    <div class="d-flex align-items-center">
      <div class="icon">
        <span class="material-symbols-outlined" style="cursor: default !important;"> other_admission </span>
      </div>
      <div class="heading">Artifactory</div>
    </div>
    <span class="material-symbols-outlined other_icon">
      settings
    </span>
  </div>
  <div class="table-container">
    <ul class="mb-0">
        <li *ngFor="let item of artifactory" (click)="navigateToArtifactory(item.category)">
            <!-- Use flexbox for layout -->
            <div class="list-item">
                <!-- Left part (category) -->
                <span class="category">{{ item.category }}</span>
                <!-- Right part (count) -->
                <span class="count">{{  item.docCount }}</span>
            </div>
        </li>
    </ul>
</div>
</mat-card>